import background from './Images/csTrial_background.jpg'
import poster from './Images/cs_landing.jpg'

var info = {
  title: 'CounterSketch | Request Trial',
  video: 'https://gemvision.com/sharedMedia/cs_landing_video_with_music.mp4',
  poster: poster,
  background: background,
  logo: 'https://gemvision.com/Images/CounterSketch/CounterSketch-Primary-Logo-2-Color.svg',
  moto: 'Request Trial',
  description1:
    'Request a 15-day FREE trial to experience CounterSketch first hand! Amaze yourself with the vast functionalities CounterSketch offers you from quick custom jewelry design throughout quoting and manufacturing. One of our global sales teams will call to learn more about your business and set up a trial that suits your needs.',
  description2: 'What can you expect? ',
  descriptionList: [
    'Receive trained materials to start learning by doing.',
    'Get technical assistance when needed.',
    'No commitment is required.'
  ],
  buttonColor: '#3f6cb4',
  titleBackgroundColor: '#211f22'
}

export default info
